import { Routes } from "@angular/router"

export const FINANZAS_ROUTES = {
    ORDEN_SERVICIO: {
        HOME: "service-order-home"
    }
}

export const FinanzasRoutes: Routes = [
    {
        path: FINANZAS_ROUTES.ORDEN_SERVICIO.HOME,
        loadComponent: () => import("./orden-servicio/presentacion/bandeja-orden-servicio/bandeja-orden-servicio.component").then(c => c.BandejaOrdenServicioComponent)
    }
]